import dataAccessService from '../services/service.data-access'
import axios from 'axios'

class WelcomebookManager {
  async getToken(email, password) {
    const token = await dataAccessService.loginWelcomebook(email, password)
    return token
  }

  refreshToken(context) {
    const data = { refreshToken: context.state.token.refresh || '' }
    let tokens = ''
    return axios.post('api/Welcomebook/refresh', data).then(
      (res) => {
        tokens = res.data
        context.commit('setAuthToken', tokens)
        return tokens
      }, () => {
        tokens = {}
        context.commit('setAuthToken', tokens)
        return tokens
      }
    )
  }
};
export default WelcomebookManager
